// Точка входу: шрифт Raleway (локально, кирилиця + латиниця, 400–700), стилі, TanStack Query, автентифікація, роутер,
// тости й підтвердження.
import '@fontsource/raleway/cyrillic-400.css';
import '@fontsource/raleway/cyrillic-500.css';
import '@fontsource/raleway/cyrillic-600.css';
import '@fontsource/raleway/cyrillic-700.css';
import '@fontsource/raleway/latin-400.css';
import '@fontsource/raleway/latin-500.css';
import '@fontsource/raleway/latin-600.css';
import '@fontsource/raleway/latin-700.css';
import './index.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { router } from './app/router';
import { AuthProvider } from './lib/auth';
import { queryClient } from './lib/query';
import { ConfirmHost, ToastProvider } from './ui';

const root = document.getElementById('root');
if (!root) throw new Error('Не знайдено елемент #root');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>
          <RouterProvider router={router} />
          <ConfirmHost />
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
